
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  async asyncData ({ $api, $config, $log, store, params: { pathMatch }, error }) {
    // get the page and its parent page
    const slug = pathMatch
    const slugParent = pathMatch?.split('/')?.slice(-2, -1).join('/')

    const [
      {
      data: {
        items: page = [],
      } = {},
      },
      {
        data: {
          items: pageParent = [],
        } = {},
      },
    ] = await Promise.all([
      pathMatch && $api.pages.getOneBySlug(slug, {
        domain: $config.preprEnvironmentDomainEo,
      }),
      slugParent && $api.pages.getOneBySlug(slugParent, {
        domain: $config.preprEnvironmentDomainEo,
      }),
    ])

    // check publication if exists and is complete
    if (!page || !page.length) {
      $log.warn(`Couldn't create '${slug}' page.`)
      return error({ statusCode: 404, message: 'Oeps! De pagina is niet gevonden' })
    }

    store.dispatch('breadcrumbs/set', {
      path: `/${pathMatch}`,
      width: 6,
      items: [
        {
          to: `/${slugParent}`,
          label: pageParent[0]?.title || 'Home',
        },
        {
          label: page[0]?.title,
        },
      ],
    })
    return page[0]
  },
  data () {
    return {
      id: null,
      title: null,
      subtitle: null,
      intro: null,
      featuredVideo: null,
      hero: null,
      content: null,
      seo: null,
      slug: null,
      social: null,
    }
  },
  computed: {
    preprOverwrite () {
      if (this.slug?.startsWith('nieuwsbrieven')) {
        return {
          PublicationElement: {
            NewsletterSubscribe: {
              titleSize: 'lg',
              overflowContainer: 'xs:none md:8 lg:10 xl:12',
            },
          },
        }
      } else if (this.isChristmasSuprise) {
        return {
          PublicationElement: {
            NewsletterSubscribe: {
              askName: true,
              titleSize: 'md',
              messageSuccess: this.getMessageSucces(),
              accentColor: 'black',
              textColor: 'white',
              color: 'purple-600',
            },
          },
        }
      }
      return null
    },
    isChristmasSuprise () {
      return [
        'laat-je-verrassen-ontdek-de-eo-kerstplaylist',
        'leesplezier-een-unieke-kerstspecial-van-eva',
        'samen-smullen-ontdek-dit-overheerlijke-recept',
        ].find(page => page === this.slug)
    },
  },
  methods: {
    getMessageSucces() {
      return `
        Gelukt! Jouw verrassing is onderweg!
        Je ontvangt binnen een paar minuten een mail van ons naar {email} met daarin de (download)link naar jouw verrassing.
        Open 'm snel en geniet van een moment voor jezelf in deze drukke decembermaand.`
    },
  },
}
